import GestionDenuncia from './GestionDenuncia'

export default GestionDenuncia